
import { defineComponent, computed } from 'vue'
import { useStore } from 'vuex'
import IconBase from '@/common/components/ui/icons/IconBase.vue'
import IconButton from '@/common/components/ui/icons/IconButton.vue'

export default defineComponent({
    name: 'MenuButton',
    components: {
        IconBase,
        IconButton,
    },
    setup() {
        const store = useStore()

        const menuState = computed(() => store.getters['ui/menuState'])

        const menuToggle = () => {
            if (menuState.value === 'opened') {
                store.dispatch('ui/setMenuState', 'closed')
            } else {
                store.dispatch('ui/setMenuState', 'opened')
            }
        }

        return {
            menuState,
            menuToggle,
        }
    },
})
